import {
  React,
  useState,
  useEffect
} from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Select,
  Slider,	
  Tab,
  Typography ,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';

const ModeButtons = (props) => {
  const { sendCommand,
          speed,
          wind_safe_override,
          stow_override,
          maintenance_mode
        } = props;
  
  const [sliderValue, setSliderValue] = useState(50);

  useEffect(() => { 
    setSliderValue(speed);
  }, [props]);


  const sliderStyle= {
     color:"green",
  	 width: "96%",
  	 margin: "2%"
  }

  const modeStyle = {
    backgroundColor:"#cccccc",
    color:"green",
    margin:"2%",
    marginTop:"0%",
    width: "92%",
    height: "50px"
  };

  const modeSelectedStyle = {
    backgroundColor:"green",
    color:"white",
    margin:"2%",
    marginTop:"0%",
    width: "92%",
    height: "50px"
  };

  const modeDisablesStyle = {
    backgroundColor:"#dddddd",
    color:"#cccccc",
    margin:"2%",
    marginTop:"0%",
    width: "92%",
    height: "50px"
  };

  return (
    <Grid
      container
      spacing={1}
    >
    	<Grid 
    	  item
		  lg={12}
          md={12}
          xl={12}
          xs={12}
    	>
    	 <Typography style={{ marginTop: "2%"}}>
        	Set Speed:
      	 </Typography>
    	 <Slider
    	    style={sliderStyle}
  			  aria-label="Always visible"
  			  value={sliderValue}
  			  step={100}
  			  min={10}
  		  	max={3500}
  			  valueLabelDisplay="auto"
		  />

    	</Grid>
    	<Grid 
    	  item
		  lg={6}
          md={6}
          xl={6}
          xs={6}
    	>
    	  <Button 
          onClick={() => {
            sendCommand("wind_safe_override", !wind_safe_override);
          }}
          style={wind_safe_override ? modeSelectedStyle:modeStyle}
          variant="contained">
            Wind Safe Mode
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={6}
          md={6}
          xl={6}
          xs={6}
    	>
    	 <Button 
          onClick={() => {
            sendCommand("stow_override", !stow_override);
          }}
          style={stow_override ? modeSelectedStyle:modeStyle} 
          variant="contained">
              Stow Dish
       </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={6}
          md={6}
          xl={6}
          xs={6}
    	>
    	  <Button 
          style={modeDisablesStyle} 
          disabled 
          variant="contained">
            Limit Switch Override
        </Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={6}
          md={6}
          xl={6}
          xs={6}
    	>
    	  <Button
           onClick={() => {
            sendCommand("maintenance_mode", !maintenance_mode);
          }}
          style={maintenance_mode ? modeSelectedStyle:modeStyle} 
          variant="contained">
            Maintenance Mode
        </Button>
    	</Grid>
    	<Grid 
    	  item
		     lg={6}
          md={6}
          xl={6}
          xs={6}
    	>
    	 <Button style={modeDisablesStyle} disabled variant="contained">Refresh Config</Button>
    	</Grid>
    	<Grid 
    	  item
		  lg={6}
          md={6}
          xl={6}
          xs={6}
    	>
    	 <Button style={modeStyle} variant="contained">Calibrate AZ</Button>
    	</Grid>

    </Grid>
  );
}

ModeButtons.propTypes = {
};
export default ModeButtons;
